import React, { useState, useEffect, useRef } from "react";
import { searchExchangePair } from "../../../../actions/bot-action";
import { connect } from "react-redux";
import "./SymbolSearchBox.scss";

const SymbolSearchBox = (props) => {
  const {
    searchExchangePair,
    selectedExchange,
    selected,
    selectedPair,
    rentBot
  } = props;
  const [searchTerm, setSearchTerm] = useState(selectedPair ? selectedPair.label  : "");
  const [results, setResults] = useState([]);
  const [emptyResult, setEmptyResult] = useState(false);
  const searchBoxRef = useRef(null);
  const requestIdRef = useRef(0); // Keep track of the latest request ID

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (
      searchBoxRef.current &&
      !searchBoxRef.current.contains(event.target) &&
      event.target.tagName !== "LI" // Check if clicked element is an <li> element
    ) {
      resetSearch();
    }
  };

  const resetSearch = () => {
    setResults([]);
    setEmptyResult(false);
  };

  const handleInputChange = (event) => {
    let symbol = event.target.value;
    if (symbol.includes("/")) {
      symbol = symbol.split("/")[0];
    }
    setSearchTerm(symbol);

    if (symbol) {
      const currentRequestId = ++requestIdRef.current;
      searchExchangePair(selectedExchange.id, symbol,rentBot?rentBot.rent_id:false).then((res) => {
        // Only handle response if it's for the latest request
        if (currentRequestId === requestIdRef.current) {
          if (res.length > 0) {
            setResults(res);
            setEmptyResult(false);
          } else {
            setResults([]);
            setEmptyResult(true);
          }
        }
      });
    } else {
      setEmptyResult(true);
      setResults([]);
    }
  };

  const handleResultClick = (symbol) => {
    setResults([]);
    setEmptyResult(false);
    if (symbol) {
      selected(symbol);
      setSearchTerm(symbol.pair.from + "/" + symbol.pair.to + (symbol.is_crypto ? " (Crypto)" : ""));
    }
  };

  return (
    <div>
      <input
        type="text"
        value={searchTerm}
        onChange={handleInputChange}
        placeholder="Enter stock symbol to trade"
        ref={searchBoxRef}
      />
      <div>
        {results.length > 0 && (
          <ul className="search-results">
            {results.map((result, index) => (
              <li
                key={index}
                onClick={(event) => {
                  event.stopPropagation(); // Prevent event propagation
                  handleResultClick(result);
                }}
              >
                {result.pair.from + "/" + result.pair.to}{result.is_crypto ? " (Crypto)" : ""}
              </li>
            ))}
          </ul>
        )}
        {results.length === 0 && emptyResult && (
          <ul className="search-results">
            <li onClick={() => resetSearch()}>No stocks found</li>
          </ul>
        )}
      </div>
    </div>
  );
};

export default connect(null, { searchExchangePair })(SymbolSearchBox);
